module.exports = "/_next/static/images/dash-41a115cf379ee99313e477ce0ae08163.png";